/**
 * Pure selection rules for the Use Case Explorer's side-by-side compare.
 *
 * Deliberately dependency-free (no React, no router) so the rules can be exercised by
 * scripts/test-compare.mjs without a DOM or a test framework. The React binding that
 * reads/writes these through the URL lives in ../hooks/useCompareSelection.
 */

export const MAX_COMPARE = 3;
export const MIN_COMPARE = 2;

/**
 * Parse the `compare` query param into a selection.
 * The param is user-editable, so never trust its shape: drop empty segments, dedupe,
 * and enforce the cap.
 */
export function parseCompareParam(raw: string | null | undefined): string[] {
  if (!raw) return [];
  return [...new Set(raw.split(',').filter(Boolean))].slice(0, MAX_COMPARE);
}

/** Selection after checking/unchecking `id`. Adding beyond the cap is a no-op. */
export function nextSelection(current: string[], id: string): string[] {
  if (current.includes(id)) return current.filter((x) => x !== id);
  if (current.length >= MAX_COMPARE) return current;
  return [...current, id];
}

/** Serialize a selection back to the `compare` param, or null when empty. */
export function toCompareParam(ids: string[]): string | null {
  return ids.length ? ids.join(',') : null;
}
